<div class="bg-[#F8F8FE] rounded-lg border border-[#723CEB] shadow-sm p-4">
  <!-- Info Grid -->
  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
    @for (item of items; track item.label) {
      <div class="flex items-start gap-3">
        <label
          class="text-[13px] font-medium text-gray-500 tracking-wide whitespace-nowrap min-w-[120px] flex-shrink-0"
        >{{ item.label }} :</label>
        <p class="text-[13px] font-semibold text-gray-900 break-words">
          {{ item.value || "-" }}
        </p>
      </div>
    }
  </div>
</div>

